import { render, staticRenderFns } from "./Richiesta.vue?vue&type=template&id=4ac456a2"
import script from "./Richiesta.vue?vue&type=script&lang=js"
export * from "./Richiesta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_2cae27f83758b46b73a9745eca16177c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports